import { TpDataObject, TpETLObjectTypes } from './interfaces';
import { DataObjectText } from './DataObjectText';
import { DataObjectTable } from './DataObjectTable';
import { DataObjectMatrix } from './DataObjectMatrix';

type TpDataObjectProps = {
  data: TpDataObject;
};

export function DataObject(props: TpDataObjectProps) {
  const dataType = props.data.type;
  switch (dataType) {
    case TpETLObjectTypes.TABLE:
      return <DataObjectTable table={props.data} />;
    case TpETLObjectTypes.TEXT:
      return <DataObjectText text={props.data} />;
    case TpETLObjectTypes.MATRIX:
      return <DataObjectMatrix matrix={props.data} />;
    default:
      // Exhaustive check for TypeScript
      throw dataType satisfies never;
  }
}
